import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthenticationServiceImpl } from '../authentication/authentication-service-impl.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly authenticationService: AuthenticationServiceImpl
  ) {}

  private readonly LAB_USER_PREFIX = 'LAB';

  private readonly EFAN = 'efan';

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authenticationService.getToken();
    if (token) {
      const efan = JSON.parse(
        JSON.stringify(this.authenticationService.userProfile)
      )[this.EFAN];

      if (efan && efan.startsWith(this.LAB_USER_PREFIX)) {
        window.location.href = environment.welcomeUrl;
      }

      const modifiedRequest = request.clone({
        setHeaders: {
          Authorization: token,
        },
      });
      return next.handle(modifiedRequest);
    }
    return next.handle(request);
  }
}
